<div [formGroup]="form">
  <div class="card mt-3">
    <div class="card-header">
      <a id="TargetKontaktdaten"></a>
      <h3>
        <i class="icon-wohnanschrift"></i> <span i18n>Kontaktdaten</span>
        <span class="float_right" *ngIf="appConfig.isAssistantAvailable">
          <button type="button" class="btn btn-primary btn-assistent mb-1 me-1" (click)="enableAssistant()"
                  style="width: 170px; background-color: #367297">
            <i class="icon-assistant" style="font-size: 20px; vertical-align: text-bottom"></i>
            <span i18n>Assistent starten</span></button>
        </span>
      </h3>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="float-start card-header card-header-detail" i18n *ngIf="appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'">
              Aktuelle Anschrift und Erreichbarkeit
            </div>
            <div class="float-start card-header card-header-detail" i18n *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'">
              Wohnanschrift des/der Antragstellenden
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="antragsteller.personendaten.staendigeAnschrift.strasse" i18n [class.mandatory]="isMandatory('anschriftStrasse')">Straße:</label>
                    <input id="antragsteller.personendaten.staendigeAnschrift.strasse"
                           type="text" appToUpperCase [attr.maxlength]="getMaxLength('anschriftStrasse')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['anschriftStrasse'])"
                           formControlName="anschriftStrasse"
                           [ngbPopover]="popover_antragsteller_personendaten_staendigeAnschrift_strasse"
                           appSaveLastFocussed
                    >
                    <ng-template #popover_antragsteller_personendaten_staendigeAnschrift_strasse>
                      <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span
                          i18n>Bitte beachten Sie, dass hier Angaben zur tatsächlichen Wohnanschrift des/der Antragstellenden erforderlich sind.</span>
                      </app-assistant>
                      <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier die Straße der aktuellen Wohnanschrift des/der Antragstellenden ein.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="antragsteller.personendaten.staendigeAnschrift.hausnummer" i18n
                           [class.mandatory]="isMandatory('anschriftHausnummer')">Hausnummer:</label>
                    <input id="antragsteller.personendaten.staendigeAnschrift.hausnummer"
                           type="text" appToUpperCase [attr.maxlength]="getMaxLength('anschriftHausnummer')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['anschriftHausnummer'])"
                           formControlName="anschriftHausnummer"
                           [ngbPopover]="popover_antragsteller_personendaten_staendigeAnschrift_hausnummer"
                           appSaveLastFocussed
                    >
                    <ng-template #popover_antragsteller_personendaten_staendigeAnschrift_hausnummer>
                      <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span
                          i18n>Bitte beachten Sie, dass hier Angaben zur tatsächlichen Wohnanschrift des/der Antragstellenden erforderlich sind.</span>
                      </app-assistant>
                      <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier die Hausnummer der aktuellen Wohnanschrift des/der Antragstellenden ein.</span>
                      </app-assistant>
                    </ng-template>

                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="antragsteller.personendaten.staendigeAnschrift.sonstigeAdressangaben" i18n
                           [class.mandatory]="isMandatory('anschriftSonstiges')">Sonstige Adressangaben:</label>
                    <input id="antragsteller.personendaten.staendigeAnschrift.sonstigeAdressangaben"
                           type="text" appToUpperCase [attr.maxlength]="getMaxLength('anschriftSonstiges')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['anschriftSonstiges'])"
                           formControlName="anschriftSonstiges"
                           [ngbPopover]="popover_antragsteller_personendaten_staendigeAnschrift_sonstigeAdressangaben"
                           appSaveLastFocussed
                    >
                    <ng-template #popover_antragsteller_personendaten_staendigeAnschrift_sonstigeAdressangaben>
                      <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier ggf. zusätzliche Details zur tatsächlichen Wohnanschrift des/der Antragstellenden ein.</span>
                      </app-assistant>
                      <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier ggf. zusätzliche Details zur aktuellen Wohnanschrift des/der Antragstellenden ein.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="antragsteller.personendaten.staendigeAnschrift.plz" i18n
                           [class.mandatory]="isMandatory('anschriftPLZ')">Postleitzahl:</label>
                    <input id="antragsteller.personendaten.staendigeAnschrift.plz"
                           type="text" appToUpperCase [attr.maxlength]="getMaxLength('anschriftPLZ')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['anschriftPLZ'])"
                           formControlName="anschriftPLZ"
                           [ngbPopover]="popover_antragsteller_personendaten_staendigeAnschrift_plz"
                           appSaveLastFocussed
                    >
                    <ng-template #popover_antragsteller_personendaten_staendigeAnschrift_plz>
                      <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span
                          i18n>Bitte beachten Sie, dass hier Angaben zur tatsächlichen Wohnanschrift des/der Antragstellenden erforderlich sind.</span>
                      </app-assistant>
                      <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier die Postleitzahl der aktuellen Wohnanschrift des/der Antragstellenden ein.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="antragsteller.personendaten.staendigeAnschrift.ort" i18n [class.mandatory]="isMandatory('anschriftOrt')">Ort:</label>
                    <input id="antragsteller.personendaten.staendigeAnschrift.ort"
                           type="text" appToUpperCase [attr.maxlength]="getMaxLength('anschriftOrt')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['anschriftOrt'])"
                           formControlName="anschriftOrt"
                           [ngbPopover]="popover_antragsteller_personendaten_staendigeAnschrift_ort"
                           appSaveLastFocussed
                    >
                    <ng-template #popover_antragsteller_personendaten_staendigeAnschrift_ort>
                      <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span
                          i18n>Bitte beachten Sie, dass hier Angaben zur tatsächlichen Wohnanschrift des/der Antragstellenden erforderlich sind.</span>
                      </app-assistant>
                      <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier den Wohnort der aktuellen Wohnanschrift des/der Antragstellenden ein.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="antragsteller.personendaten.staendigeAnschrift.land" i18n
                           [class.mandatory]="isMandatory('anschriftLand')">Land:</label>
                    <select class="form-select form-select-sm"
                            id="antragsteller.personendaten.staendigeAnschrift.land"
                            [class.is-invalid]="errorClassRequired(form.controls['anschriftLand'])"
                            formControlName="anschriftLand"
                            [ngbPopover]="popover_antragsteller_personendaten_staendigeAnschrift_land"
                            appSaveLastFocussed
                    >
                      <option value=""></option>
                      <option *ngFor="let listItem of landListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                    </select>
                    <ng-template #popover_antragsteller_personendaten_staendigeAnschrift_land>
                      <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span
                          i18n>Bitte beachten Sie, dass hier Angaben zur tatsächlichen Wohnanschrift des/der Antragstellenden erforderlich sind.</span>
                      </app-assistant>
                      <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier das Land der aktuellen Wohnanschrift des/der Antragstellenden ein.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="antragsteller.personendaten.staendigeAnschrift.kontaktdaten.telefon" i18n
                           [class.mandatory]="isMandatory('anschriftTelefon')">Telefon-/Mobilfunknummer:</label>
                    <input id="antragsteller.personendaten.staendigeAnschrift.kontaktdaten.telefon"
                           type="text" appToUpperCase [attr.maxlength]="getMaxLength('anschriftTelefon')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['anschriftTelefon'])"
                           formControlName="anschriftTelefon"
                           [ngbPopover]="popover_antragsteller_personendaten_staendigeAnschrift_kontaktdaten_telefon"
                           appSaveLastFocussed
                    >
                    <ng-template #popover_antragsteller_personendaten_staendigeAnschrift_kontaktdaten_telefon>
                      <app-assistant (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier die aktuelle Telefon- /Mobilfunknummer des/der Antragstellenden ein.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="antragsteller.personendaten.staendigeAnschrift.kontaktdaten.email" i18n
                           [class.mandatory]="isMandatory('anschriftEmail')">E-Mail:</label>
                    <input id="antragsteller.personendaten.staendigeAnschrift.kontaktdaten.email"
                           type="text" appToUpperCase [attr.maxlength]="getMaxLength('anschriftEmail')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['anschriftEmail'])"
                           formControlName="anschriftEmail"
                           [ngbPopover]="popover_antragsteller_personendaten_staendigeAnschrift_kontaktdaten_email"
                           appSaveLastFocussed
                    >
                    <ng-template #popover_antragsteller_personendaten_staendigeAnschrift_kontaktdaten_email>
                      <app-assistant (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier die aktuelle E-Mail-Adresse des/der Antragstellenden ein.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <div>
                      <!-- C-Visa -->
                      <app-pass-restricted-checkbox
                        *ngIf="isCVisum"
                        [control]="form.controls.wohnsitzAnderesLandAuswahl"
                        [title]="wohnsitzTitleKey"
                        [labels]="wohnsitzLabels"
                        [required]="true"
                        [selectedCheckbox$]="wohnsitzAnderesLandSelected$"
                        [ngbPopover]="popover_antragsteller_aufenthaltsberechtigung"
                        appSaveLastFocussed
                      ></app-pass-restricted-checkbox>

                      <!-- D-Visa -->
                      <div *ngIf="isDVisum" class="mb-2">
                        <label i18n class="d-block mb-1">
                          Haben Sie Ihren Wohnsitz in einem anderen Staat als dem, dessen Staatsangehörigkeit Sie aktuell besitzen?
                        </label>

                        <div class="form-check">
                          <input id="antragsteller.aufenthaltsberechtigung"
                                 type="checkbox"
                                 class="form-check-input"
                                 formControlName="wohnsitzAnderesLand"
                                 [ngbPopover]="popover_antragsteller_aufenthaltsberechtigung"
                                 appSaveLastFocussed>
                          <label class="form-check-label" for="antragsteller.aufenthaltsberechtigung" i18n>Ja</label>
                        </div>
                      </div>

                      <ng-template #popover_antragsteller_aufenthaltsberechtigung>
                        <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                       (assistantDisabled)="disableAssistant()">
                          <span i18n>Sollte der/die Antragstellende nicht die Staatsangehörigkeit des Staates besitzen, in dem er/sie tatsächlich lebt, wählen Sie hier bitte Ja.</span>
                        </app-assistant>
                        <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                       (assistantDisabled)="disableAssistant()">
                          <span i18n>Sollte der/die Antragstellende nicht die Staatsangehörigkeit des Staates besitzen, in dem er/sie den Wohnsitz hat, wählen Sie hier bitte Ja, ansonsten Nein.</span>
                        </app-assistant>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="(isCVisum && form.value.wohnsitzAnderesLandAuswahl === 'YES') || (isDVisum && form.value.wohnsitzAnderesLand === true)" class="card mt-3">
            <div class="card-header card-header-detail" i18n>Angaben zur Aufenthaltsberechtigung am Wohnort</div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <label for="antragsteller.aufenthaltsberechtigung.artDerRueckkehrberechtigung" i18n
                         [class.mandatory]="isMandatory('aufenthaltsberechtigungArt')"
                         *ngIf="appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'">Art des Aufenthaltstitels:</label>
                  <label for="antragsteller.aufenthaltsberechtigung.artDerRueckkehrberechtigung" i18n
                         [class.mandatory]="isMandatory('aufenthaltsberechtigungArt')"
                         *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'">Art der Rückkehrberechtigung/des
                    Aufenthaltstitels:</label>
                </div>
                <div class="col-md-4">
                  <label for="antragsteller.aufenthaltsberechtigung.rueckkehrDokumentNr" i18n
                         [class.mandatory]="isMandatory('aufenthaltsberechtigungNummer')"
                         *ngIf="appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'">Nummer des Aufenthaltstitels:</label>
                  <label for="antragsteller.aufenthaltsberechtigung.rueckkehrDokumentNr" i18n
                         [class.mandatory]="isMandatory('aufenthaltsberechtigungNummer')"
                         *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'">Nummer der Rückkehrberechtigung/des
                    Aufenthaltstitels:</label>
                </div>
                <div class="col-md-4">
                  <label for="antragsteller.aufenthaltsberechtigung.rueckkehrGueltigBis" i18n="@@gultig-bis-tt-mm-jjjj"
                         [class.mandatory]="isMandatory('aufenthaltsberechtigungGueltigkeitbis')">Gültig bis (TT.MM.JJJJ):</label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="mb-3">
                    <input id="antragsteller.aufenthaltsberechtigung.artDerRueckkehrberechtigung"
                           type="text" appToUpperCase [attr.maxlength]="getMaxLength('aufenthaltsberechtigungArt')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['aufenthaltsberechtigungArt'])"
                           formControlName="aufenthaltsberechtigungArt"
                           [ngbPopover]="popover_antragsteller_aufenthaltsberechtigung_artDerRueckkehrberechtigung"
                           appSaveLastFocussed
                    >
                    <ng-template #popover_antragsteller_aufenthaltsberechtigung_artDerRueckkehrberechtigung>
                      <app-assistant (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier die Art der Aufenthaltsgenehmigung des/der Antragstellenden ein.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <input id="antragsteller.aufenthaltsberechtigung.rueckkehrDokumentNr"
                           type="text" appToUpperCase [attr.maxlength]="getMaxLength('aufenthaltsberechtigungNummer')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['aufenthaltsberechtigungNummer'])"
                           formControlName="aufenthaltsberechtigungNummer"
                           [ngbPopover]="popover_antragsteller_aufenthaltsberechtigung_rueckkehrDokumentNr"
                           appSaveLastFocussed
                    >
                    <ng-template #popover_antragsteller_aufenthaltsberechtigung_rueckkehrDokumentNr>
                      <app-assistant (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier die Nummer der Aufenthaltsgenehmigung des/der Antragstellenden ein.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="input-group" *ngIf="presentationModeEnum.DEFAULT === appConfig.presentationMode">
                    <input angular-mydatepicker
                           id="antragsteller.aufenthaltsberechtigung.rueckkehrGueltigBis"
                           #inputVisumsdatenGueltigVon="angular-mydatepicker"
                           [options]="datepickerOptions"
                           class="form-control form-control-sm w-50"
                           type="text"
                           [class.is-invalid]="errorClassRequired(form.controls['aufenthaltsberechtigungGueltigkeitbis'])"
                           [attr.maxlength]="getMaxLength('aufenthaltsberechtigungGueltigkeitbis')"
                           formControlName="aufenthaltsberechtigungGueltigkeitbis"
                           (inputFieldChanged)="onDatePickerInputFieldChanged('aufenthaltsberechtigungGueltigkeitbis', $event)"
                           (blur)="onDatePickerBlur('aufenthaltsberechtigungGueltigkeitbis')"
                           [ngbPopover]="popover_antragsteller_aufenthaltsberechtigung_rueckkehrGueltigBis"
                           appSaveLastFocussed
                    />
                    <ng-template #popover_antragsteller_aufenthaltsberechtigung_rueckkehrGueltigBis>
                      <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier ein, bis wann die Aufenthaltsgenehmigung des/der Antragstellenden gültig ist. Falls der Aufenthaltstitel unbefristet ist, geben Sie bitte das Ablaufdatum der entsprechenden Karte, ersatzweise das Ablaufdatum des Reisepasses ein.</span>
                      </app-assistant>
                      <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier das Gültigkeitsdatum der Aufenthaltsgenehmigung des/der Antragstellenden ein.</span>
                      </app-assistant>
                    </ng-template>
                    <span class="input-group-text date-picker" (click)="inputVisumsdatenGueltigVon.toggleCalendar()"><i
                      class="icon-calendar"></i></span>
                  </div>
                  <div class="input-group" *ngIf="presentationModeEnum.AP2 === appConfig.presentationMode">
                    <input type="text"
                           class="form-control form-control-sm w-50"
                           value="{{dateFormatter.getFormattedDatePickerValue(form.value.aufenthaltsberechtigungGueltigkeitbis)}}"
                           disabled
                    />
                    <span class="input-group-text date-picker"><i class="icon-calendar"></i></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
